import React from 'react';
import { Button } from 'flowbite-react';
import { useUserContext } from 'src/context/UserProvider';
import { HiExternalLink } from 'react-icons/hi';

const HelpdeskSection = () => {
    const { user } = useUserContext();

    // Zoom links and timing based on role
    const helpdeskInfo = {
        CAP: {
            link: 'https://us06web.zoom.us/j/86558858929',
            timing: 'Mon - Fri (7:00 - 7:30 PM)',
        },
        IIT: {
            link: 'https://us06web.zoom.us/j/86336411337',
            timing: 'Mon - Fri (7:00 - 8:00 PM)',
        },
        MasaiStudent: {
            link: 'https://us06web.zoom.us/j/85707260795',
            timing: 'Mon - Fri (6:00 - 7:00 PM)',
        },
        MasaiAlum: {
            link: 'https://us06web.zoom.us/j/81448425087',
            timing: 'Mon - Fri (6:00 - 8:00 PM)',
        },
    };

    // Get user's subRole (case-insensitive)
    const userSubRole = user?.subRole?.toUpperCase();
    const helpdeskData = userSubRole === 'CAP'
        ? helpdeskInfo.CAP
        : userSubRole === 'IIT'
            ? helpdeskInfo.IIT
            : userSubRole === 'MasaiStudent'
                ? helpdeskInfo.MasaiStudent
                : userSubRole === 'MasaiAlum'
                    ? helpdeskInfo.MasaiAlum
            : null;

    // If no matching role, don't show the section
    if (!helpdeskData) {
        return null;
    }

    return (
        <div className="bg-white dark:bg-[#1F2A37] rounded-[8px] border dark:border-gray-700 p-6">
            <h2 className="text-xl font-semibold font-inter mb-4 dark:text-white">
                Helpdesk
            </h2>
            <div className="flex flex-col gap-3">
                <p className="text-sm md:text-base font-inter text-[#555770] dark:text-[#E4E4EB]">
                    Need help? Join our helpdesk session on Zoom.
                    {/* {userSubRole && (
                        <span className="ml-1 font-medium">({userSubRole})</span>
                    )} */}
                </p>
                <div className="text-sm font-inter text-[#555770] dark:text-[#E4E4EB] font-medium">
                    Timing: {helpdeskData.timing}
                </div>
                <Button
                    color="purplePlaced"
                    onClick={() => window.open(helpdeskData.link, '_blank')}
                    className="w-fit"
                    size="sm"
                >
                    <span className="flex items-center gap-2">
                        Join Helpdesk Session
                        <HiExternalLink className="w-4 h-4" />
                    </span>
                </Button>
            </div>
        </div>
    );
};

export default HelpdeskSection;

